export const getRowId = (row: object): string => {
    return (row as { id: string }).id;
};
